function LandingPage() {
    return (
        <>
            <h1>This website displays random popular movies provided by API data from https://www.themoviedb.org/</h1>
            <h1>Data can be saved and retrieved from a MongoDB NoSQL database.</h1>
            <h1>Database functionality unavailable on this live page hosted via github-pages. In order to use that feature, clone this repo down and follow the instructions in the readme to run the backend Node.js server.</h1>
        </>
    )
}

export default LandingPage;